@switch (renderMode()) {
  @case ('image') {
    <img
      class="ppg-background-color-image-content relative"
      [alt]="alt()"
      [ngSrc]="imageUrl()"
      fill
      (error)="imageLoadFailed()"
      (load)="imageLoaded()" />
  }

  @case ('rgb') {
    <div class="ppg-background-color-rgb-content h-full w-full" [style.background-color]="bgColor()"></div>
  }
}
